import COMMON_ROUTES from '../common/routes'

const mergedRoutes = {
  ...COMMON_ROUTES,

  // Transfer account — getuniq only:
  // SERVICES_NETWORK_TRANSFER_ACCOUNTS: `/:i18n/services/:networkType(yd)/transfer-accounts`,
  // SERVICES_NETWORK_ACCOUNT_TRANSFER: '/:i18n/:transferNetwork(yd)/transfer-account',
  // BILLING_ACCOUNT_TRANSFER_PAYMENT:
  //   '/:i18n/billing/:transferNetwork(yd)/transfer-account/:requestId([0-9]+)/payment',

  ACCOUNTS_MARKETPLACE: '/:i18n/accounts-marketplace',
  ACCOUNTS_MARKETPLACE_CATEGORY: '/:i18n/accounts-marketplace/category/:categoryId([0-9]+)',
  ACCOUNTS_MARKETPLACE_CATEGORY_PRODUCTS:
    '/:i18n/accounts-marketplace/category/:categoryId([0-9]+)/products',
  ACCOUNTS_MARKETPLACE_PRODUCT:
    '/:i18n/accounts-marketplace/category/:categoryId([0-9]+)/products/:productId([0-9]+)',

  OFERTA: '/:i18n/terms-and-conditions',
}

export { mergedRoutes as ROUTES }
